
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/impressum/impressum-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="impressum-view">
        <hero-section
            background-image="/images/hero/rechtliches-hero.png"
            headline="Impressum"
            subheadline="Impressum von FASE2"
            text="<strong>Hier finden sie unsere rechtlichen Angaben.</strong><br>Transparent und rechtlich konform."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="impressum-heading">
                <hex-headline id="impressum-heading" left text="Impressum"></hex-headline>
                <p>
                    FASE2 eGbR Facility & Instandhaltung<br>
                    Reinoldstr. 6b, 50676 Köln<br>
                    <b>Handelsregister</b>: HRB 861<br>
                    <b>Registergericht</b>: Amtsgericht Köln
                </p>

                <p>
                    <b>Vertreten durch:</b><br>
                    Salvatore Laudani & Hüseyin Sidar
                </p>
            </article>

            <article aria-labelledby="kontakt-heading">
                <h3 id="kontakt-heading">Kontakt</h3>

                <p>
                    Telefon: <a href="tel:+4922194085999">+49 (0) 221 94085999</a><br>
                    E-Mail: <a href="mailto:hallo@fase2.de?subject=Anfrage">hallo@fase2.de</a>
                </p>
            </article>

            <article aria-labelledby="ustid-heading">
                <h3 id="ustid-heading">Umsatzsteuer-ID</h3>

                <p>
                    Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br>
                    DE370600099
                </p>
            </article>

            <article aria-labelledby="verantwortlich-heading">
                <h3 id="verantwortlich-heading">Redaktionell verantwortlich</h3>

                <p>
                    Salvatore Laudani & Hüseyin Sidar<br>
                    Gesellschafter<br>
                    Reinoldstr. 6b<br>
                    50676 Köln
                </p>
            </article>

            <article aria-labelledby="streitschlichtung-heading">
                <h3 id="streitschlichtung-heading">EU-Streitschlichtung</h3>

                <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank">https://ec.europa.eu/consumers/odr/</a>.<br>
                    Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
            </article>

            <article aria-labelledby="verbraucherschlichtung-heading">
                <h3 id="verbraucherschlichtung-heading">Verbraucher&shy;streit&shy;beilegung / Universalschlichtungs&shy;stelle</h3>

                <p>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
            </article>

            <article aria-labelledby="quellenangabe-heading">
                <h3 id="quellenangabe-heading">Quellenangaben</h3>

                <p>
                    Im Sinne größtmöglicher Transparenz und zur Wahrung urheberrechtlicher Bestimmungen finden 
                    Sie nachfolgend die Angaben zu verwendeten Icons und Grafiken externer Anbieter.
                </p>

                <p>
                    <a href="https://www.flaticon.com/free-icons/partner" title="partner icons" target="_blank" rel="noopener noreferrer">
                        Partner icons created by Smashicons - Flaticon
                    </a>
                </p>
            </article>
        </div>
    </section>`,
      style: `impressum-view .impressum-view {
  margin: 0;
  padding: 0;
}
impressum-view .impressum-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
impressum-view .impressum-view .wrapper article {
  margin: 32px 0 0 0;
  padding: 0;
}
impressum-view .impressum-view .wrapper article:first-of-type {
  margin: 0 0 0 0;
}
impressum-view .impressum-view .wrapper aside {
  margin: 32px 0 0 0;
  padding: 0;
}
@media (max-width: 992px) {
  impressum-view .impressum-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    events: [
        ['click', '.widerrufsbelehrung-view a[href^="/"]:not([target])', function (event) {
                event.preventDefault();
                if (this.buttonLink2)
                    router.navigate(this.buttonLink2);
            }],
    ]
};
 })()`
    };
  